import { render } from "./SpaShowComponent.vue?vue&type=template&id=8c6c9394"
import script from "./SpaShowComponent.vue?vue&type=script&lang=js"
export * from "./SpaShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__